export default class BlockCustomerDiving {
    divingData = $('[data-element="diving-data"]').data('diving-data')

    constructor() {
        if ($('[data-element="block-customer-diving"]').length > 0) {
            this.buildFilters()
            this.actionsIsland()
            this.buildTooltips()
            this.buildMobileList()
        }
    }

    buildFilters() {
        const component = this
        $('[data-filter]').hover(function () {
            const target = $(this).data('filter-value')
            component.displayIslands(target)
        })
        $('[data-filter]').on('mouseleave', () => {
            $('.island').removeClass('current').removeClass('not-current')
        })
    }

    displayIslands(target) {
        const islands = this.getIslandsByType(target)
        for (const island of islands) {
            $(`[data-island=${island}]`).addClass('current')
        }
        $('.island:not(.current)').addClass('not-current')
    }

    getIslandsByType(target) {
        const result = []
        for (const item of this.divingData) {
            const key = Object.keys(item)[0]
            if (item[key].diving.includes(target)) {
                result.push(key)
            }
        }
        return result
    }

    actionsIsland() {
        const component = this
        const $tooltip = $('.map-tooltip')

        $('.island').hover(
            function (e) {
                const islandId = $(this).data('island')
                const tooltipContent = $(`[data-tooltip='${islandId}']`).html()
                $tooltip.html(tooltipContent)
                $tooltip.show()
                $tooltip.css({
                    left: `${e.pageX - 200}px`,
                    top: `${e.pageY - 1000}px`,
                })
            },
            () => {
                $tooltip.hide()
            },
        )

        $('.block__customer__diving__container').mousemove(function (event) {
            const offset = $(this).offset()
            const mouseX = event.pageX - offset.left
            const mouseY = event.pageY - offset.top

            const divWidth = 420
            const divHeight = 410
            const newLeft = mouseX - divWidth / 2
            const newTop = mouseY - divHeight

            $tooltip.css({
                left: `${newLeft}px`,
                top: `${newTop}px`,
            })
        })

        $('.island').on('click', function () {
            const islandId = $(this).data('island')
            const data = component.getDataByIsland(islandId)
            if (data.url !== '' && data.url != null) {
                window.location.href = data.url
            }
        })
    }

    buildTooltips() {
        const component = this
        let html = ''
        $('.island').each(function () {
            const islandId = $(this).data('island')
            const data = component.getDataByIsland(islandId)
            html += `<div class='tooltip-island' data-tooltip='${islandId}'>`
            html += "<div class='image'>"
            if (data.image != null && data.image !== '') {
                html += `<img src='${data.image}' />`
            }
            html += '</div>'
            html += `<p class='label'>${data.label}</p>`
            html += "<div class='icons-list'>"
            for (const icon of data.diving) {
                const iconUrl = IRISCollectionCustomer[`imageBlockDivingIcons${icon[0].toUpperCase() + icon.slice(1)}`]
                html += `<span title='${icon}'><img src='${iconUrl}' alt='${icon}' /></span>`
            }
            html += '</div>'
            html += '</div>'
        })
        $('[data-element="tooltips-container"]').html(html)
    }

    getDataByIsland(key) {
        for (const item of this.divingData) {
            if (item[key]) {
                return item[key]
            }
        }
        return null
    }

    buildMobileList() {
        const component = this
        $('[data-diving-mobile]').each(function () {
            let html = ''
            const islandId = $(this).data('diving-mobile')
            const data = component.getDataByIsland(islandId)
            for (const icon of data.diving) {
                const iconUrl = IRISCollectionCustomer[`imageBlockDivingIcons${icon[0].toUpperCase() + icon.slice(1)}`]
                html += `<span title='${icon}'><img src='${iconUrl}' alt='${icon}' /></span>`
            }
            $(this).find('.diving').html(html)
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new BlockCustomerDiving()
})
